import { useEffect, useState } from 'react'
import { BicoinLogo } from '../components/BicoinLogo'

export default function MaintenancePage() {
    const [message, setMessage] = useState('Platform is under maintenance.')

    useEffect(() => {
        const msg = sessionStorage.getItem('maintenanceMessage')
        if (msg) setMessage(msg)

        // Poll every 15s — redirect back when maintenance ends
        const interval = setInterval(async () => {
            try {
                const res = await fetch(`${import.meta.env.VITE_API_URL}/api/users/maintenance-status`)
                const data = await res.json()
                if (!data?.maintenance) {
                    window.location.href = '/'
                }
            } catch { /* ignore */ }
        }, 15000)
        return () => clearInterval(interval)
    }, [])

    return (
        <div style={{ minHeight: '100vh', background: '#0c0c17', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
            <div style={{ marginBottom: 32 }}><BicoinLogo height={48} /></div>

            <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'rgba(245,158,11,0.12)', border: '2px solid rgba(245,158,11,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 24 }}>
                <svg width="32" height="32" fill="none" stroke="#F59E0B" strokeWidth="2" viewBox="0 0 24 24">
                    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
                </svg>
            </div>

            <h1 style={{ color: '#ffffff', fontSize: 24, fontWeight: 700, marginBottom: 12, textAlign: 'center' }}>Under Maintenance</h1>
            <p style={{ color: '#a1a1aa', fontSize: 15, textAlign: 'center', maxWidth: 380, lineHeight: 1.6, marginBottom: 32 }}>{message}</p>

            <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#71717a', fontSize: 13 }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#F59E0B', animation: 'pulse 2s infinite' }} />
                Checking status every 15 seconds...
            </div>
        </div>
    )
}
